import FormFieldController from "confinus_ui/forms/form_field_controller";

export default class ButtonRadioGroupController extends FormFieldController {
  public static targets = FormFieldController.targets;
}
